/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactChatMessagesResponseData,
  GetContactChatMessagesResponseDataFromJSON,
  GetContactChatMessagesResponseDataFromJSONTyped,
  GetContactChatMessagesResponseDataToJSON
} from './GetContactChatMessagesResponseData'

/**
 *
 * @export
 * @interface GetContactChatMessagesResponse
 */
export interface GetContactChatMessagesResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactChatMessagesResponse
   */
  status?: number
  /**
   *
   * @type {GetContactChatMessagesResponseData}
   * @memberof GetContactChatMessagesResponse
   */
  data?: GetContactChatMessagesResponseData
}

export function GetContactChatMessagesResponseFromJSON(json: any): GetContactChatMessagesResponse {
  return GetContactChatMessagesResponseFromJSONTyped(json, false)
}

export function GetContactChatMessagesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactChatMessagesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactChatMessagesResponseDataFromJSON(json['data'])
  }
}

export function GetContactChatMessagesResponseToJSON(value?: GetContactChatMessagesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactChatMessagesResponseDataToJSON(value.data)
  }
}
